import { AfterContentInit, ChangeDetectorRef, Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'form',
    standalone: true,
})
export class FormFocusDirective implements AfterContentInit {
    focusables = ['input', 'select', 'textarea'];

    constructor(
        private element: ElementRef,
        private cdRef: ChangeDetectorRef
    ) {}

    ngAfterContentInit() {
        let a = 0;
        // const inputs = this.element.nativeElement.querySelectorAll(
        //   this.focusables.join(','),
        // );
        // if (inputs) {
        //   for (let index = 0; index < inputs.length; index++) {
        //     let element = inputs[index];

        //     if (element.disabled == false) {
        //       element.focus();
        //       //this.cdRef.detectChanges();
        //       break;
        //     }
        //   }
        // }
    }

    @HostListener('submit')
    submit() {
        // const input = this.element.nativeElement.querySelector(
        //   this.focusables.map((x) => `${x}.ng-invalid`).join(','),
        // )
        // if (input) {
        //   input.focus()
        // }
    }
}
